const testUrl = '/test';
const accountUrl = '/urjanetaccount';
const credentialsUrl = '/urjanetcredential';
const statementUrl = '/urjanetstatement';
const webhookUrl = '/urjanetwebhook';
export const urjanetServiceRoutes = {
  testUrl: "".concat(testUrl),
  accountUrl: "".concat(accountUrl),
  accountUrlId: id => "".concat(accountUrl, "/").concat(id),
  credentialsUrl: "".concat(credentialsUrl),
  credentialProvidersUrl: "".concat(credentialsUrl, "/providers"),
  credentialsIdUrl: id => "".concat(credentialsUrl, "/").concat(id),
  statementUrl: "".concat(statementUrl),
  providerStatementsPreviewUrl: livableProviderId => "".concat(statementUrl, "/preview/").concat(livableProviderId),
  webhookUrl: "".concat(webhookUrl)
  // providerId: (id: string) => `${baseUrl}/${id}`,
  // utility: 'utility' as const,
};